import isEmpty from 'lodash/isEmpty';

// https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-update_option
export default function payoutCheckingPrepareDataForRequest(formData) {
  const result = {
    updateOption: {
      type: formData.type,
      firstName: formData.firstName,
      lastName: formData.lastName,
    },
  };

  if (isEmpty(formData.paymentOption)) {
    // creating new

    switch (formData.type) {
      case 'ACH':
        result.updateOption.accountType = formData.accountType;
        result.updateOption.accountNumber = formData.accountNumber;
        result.updateOption.routingNumber = formData.routingNumber;
        result.addOption = result.updateOption;
        delete result.updateOption;
        break;

      case 'EFT':
        result.updateOption.accountType = formData.accountType;
        result.updateOption.accountNumber = formData.accountNumber;
        result.addOption = result.updateOption;
        delete result.updateOption;
        break;


      default:
        console.warn('uknown type of account');
        return null;
    }
  }

  return result;
  // {
  //   "addOption": {
  //     "type": "ACH",
  //     "accountType": "checking",
  //     "accountNumber": "11234567890",
  //     "routingNumber": "121000358",
  //     "firstName": "Tom",
  //     "lastName": "Jerry"
  //   }
  // }
}
